import * as yup from 'yup';
import { PressLogo } from '@web/components';
import { requiredImageFromCMSSchema } from '../schemas';

export const component = PressLogo;

export const schema = yup
  .object({
    quote: yup.string().nullable(),
    image: requiredImageFromCMSSchema,
  })
  .transform(value => {
    return {
      image: value.logo_image,
      quote: value.quote,
    };
  });
